import { createSlice } from "@reduxjs/toolkit";
import { fetchProjects, deleteProjects, fetchAllProjects } from "./projectThunks";

const initialState = {
    projects: [],
    allProjects: [], // Separate list for dropdowns (AddTaskModal, EditTaskModal)
    totalRows: 0,
    pagination: null,
    loading: false,
    error: null,
};

const projectSlice = createSlice({
    name: "projects",
    initialState,
    reducers: {
        setProjects: (state, action) => {
            state.projects = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProjects.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchProjects.fulfilled, (state, action) => {
                state.loading = false;
                state.projects = action.payload.items;
                state.totalRows = action.payload.pagination?.totalItems ?? action.payload.items.length;
                state.pagination = action.payload.pagination;
            })
            .addCase(fetchAllProjects.fulfilled, (state, action) => {
                state.allProjects = action.payload;
            })
            .addCase(fetchAllProjects.rejected, (state, action) => {
                state.error = action.payload || "Failed to fetch all projects";
            })
            .addCase(fetchProjects.rejected, (state, action) => {
                state.loading = false;
                state.projects = [];
                state.totalRows = 0;
                state.error = action.payload || "Failed to fetch projects";
            })
            .addCase(deleteProjects.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(deleteProjects.fulfilled, (state, action) => {
                state.loading = false;
                state.projects = state.projects.filter(p => !action.payload.ids.includes(p.id));
                state.totalRows -= action.payload.ids.length;
            })
            .addCase(deleteProjects.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || "Failed to delete projects";
            });
    },
});

export const { setProjects } = projectSlice.actions;
export default projectSlice.reducer;
